import Toast from 'react-native-toast-message';
import { Popup } from 'react-native-popup-confirm-toast';
import { theme } from '../core/theme';
import i18n from '../../i18n';

/**
 * ServiceModuleFeedback
 * 
 * Unified feedback system for the Service Module.
 */

export const ServiceModuleToast = {
    /**
     * Show a success toast (e.g., "Saved", "Started")
     */
    success: (title, message = '') => {
        Toast.show({
            type: 'success',
            text1: title,
            text2: message,
            visibilityTime: 3000,
            autoHide: true,
            topOffset: 60,
        });
    },

    /**
     * Show an info toast (e.g., "Break started")
     */
    info: (title, message = '') => {
        Toast.show({
            type: 'info',
            text1: title,
            text2: message,
            visibilityTime: 3000,
            autoHide: true,
            topOffset: 60,
        });
    },

    /**
     * Show an error toast
     */
    error: (title, message = '') => {
        Toast.show({
            type: 'error',
            text1: title || i18n.t('error'),
            text2: message,
            visibilityTime: 4000,
            autoHide: true,
            topOffset: 60,
        });
    }
};

export const ServiceModuleConfirm = {
    /**
     * Show a confirmation dialog
     */
    show: ({
        title,
        message,
        confirmText,
        cancelText,
        onConfirm,
        onCancel,
        type = 'warning'
    }) => {
        Popup.show({
            type: type === 'warning' ? 'danger' : type,
            title: title || i18n.t('confirm'),
            textBody: message || i18n.t('are_you_sure'),
            buttonText: confirmText || i18n.t('confirm'),
            confirmText: cancelText || i18n.t('cancel'),
            callback: () => {
                onConfirm && onConfirm();
                Popup.hide();
            },
            cancelCallback: () => {
                onCancel && onCancel();
                Popup.hide();
            },
            backgroundColor: theme.dark ? '#1e293b' : '#ffffff',
            titleStyle: { color: theme.dark ? '#ffffff' : '#1e293b' },
            descStyle: { color: theme.dark ? '#cbd5e1' : '#475569' },
        });
    }
};

export const ServiceModulePopup = {
    /**
     * Show a simple information popup with an "OK" button
     */
    info: (title, message, onOk) => {
        Popup.show({
            type: 'success',
            title: title,
            text: message,
            buttonText: i18n.t('ok'),
            callback: () => {
                onOk && onOk();
                Popup.hide();
            },
            backgroundColor: theme.dark ? '#1e293b' : '#ffffff',
            titleStyle: { color: theme.dark ? '#ffffff' : '#1e293b' },
            textStyle: { color: theme.dark ? '#cbd5e1' : '#475569' },
        });
    },

    error: (title, message) => {
        Popup.show({
            type: 'danger',
            title: title || i18n.t('error'),
            text: message,
            buttonText: i18n.t('ok'),
            callback: () => Popup.hide(),
            backgroundColor: theme.dark ? '#1e293b' : '#ffffff',
            titleStyle: { color: theme.dark ? '#ffffff' : '#1e293b' },
            textStyle: { color: theme.dark ? '#cbd5e1' : '#475569' },
        });
    }
};
